import ServiceDetailPage from "../../ones/ServiceDetailPage";
import Footer from "../../ones/Footer";
import image1 from "../../assets/banner5.jpg";
import image2 from "../../assets/banner1.jpg";
import image3 from "../../assets/banner6.jpg";

export default function ServiceSunflower() {
  return (
    <>
      <ServiceDetailPage
        label="Haulage"
        title="Aggregate Haulage"
        subtitle="Reliable transport of aggregates from NCCL production points to construction sites, road projects, and infrastructure corridors."
        overview="Our haulage service is built around dispatch timing, route discipline, and heavy transport coordination to help clients maintain uninterrupted project execution."
        images={[
          {
            src: image1,
            alt: "Aggregate transport",
            captionTitle: "Planned Dispatch",
            captionText: "Haulage planning aligned with client site delivery windows.",
          },
          {
            src: image2,
            alt: "Heavy transport route",
            captionTitle: "Route Execution",
            captionText: "Reliable movement across regional and long-distance corridors.",
          },
          {
            src: image3,
            alt: "Construction delivery",
            captionTitle: "Site Delivery",
            captionText: "Consistent supply flow to active infrastructure projects.",
          },
        ]}
        highlights={[
          "Transport scheduling matched to client construction phases.",
          "Reliable delivery for aggregates and related bulk materials.",
          "Operational coordination for continuous site support.",
        ]}
        metrics={[
          { value: "On-Time", label: "Delivery-focused routing" },
          { value: "Bulk", label: "High-volume transport support" },
          { value: "Regional", label: "Cross-area project coverage" },
        ]}
      />
      <Footer />
    </>
  );
}
